import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {Cookie, X} from 'lucide-react';
import {Link} from 'react-router-dom';

export function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem('itcams-cookies');
        if (!accepted) {
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem('itcams-cookies', 'accepted');
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem('itcams-cookies', 'declined');
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{y: 100, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    exit={{y: 100, opacity: 0}}
                    transition={{type: 'spring', damping: 25, stiffness: 200}}
                    className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] rounded-2xl bg-card border border-border/60 shadow-2xl shadow-black/10 p-5"
                >
                    <button
                        onClick={decline}
                        className="absolute top-3 right-3 w-7 h-7 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
                    >
                        <X size={14}/>
                    </button>

                    <div className="flex items-start gap-3 mb-4">
                        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                            <Cookie size={20} className="text-primary"/>
                        </div>
                        <div>
                            <h3 className="font-bold text-sm text-foreground mb-1">Pliki cookies</h3>
                            <p className="text-xs text-muted-foreground leading-relaxed">
                                Używamy plików cookies, aby zapewnić najlepsze doświadczenie na naszej stronie.
                                Dowiedz się więcej w naszej{' '}
                                <Link to="/polityka-prywatnosci"
                                      className="text-primary underline underline-offset-2 hover:text-primary-dark">
                                    polityce prywatności
                                </Link>.
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-2">
                        <button
                            onClick={accept}
                            className="flex-1 flex items-center justify-center gap-1.5 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:brightness-110 transition-all"
                        >
                            Akceptuję
                        </button>
                        <button
                            onClick={decline}
                            className="flex-1 flex items-center justify-center gap-1.5 py-2.5 rounded-xl bg-muted text-muted-foreground text-sm font-semibold hover:bg-muted/80 transition-all"
                        >
                            Odrzucam
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
